import React from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    textField: {
        width: 350,
        maxWidth: '100%',
    }
}));
function TypeInputBox(props) {
    const classes = useStyles();
    return (React.createElement(TextField, Object.assign({ inputProps: {
            style: {
                fontFamily: 'Times New Roman',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '2em',
                marginTop: '-15px',
                marginBottom: '-5px'
            },
            'aria-label': 'Typing input box'
        }, margin: 'normal', autoFocus: true, ref: props.inputRef, className: classes.textField, autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off' }, props)));
}
export default TypeInputBox;
//# sourceMappingURL=TypeInputBox.js.map